import { useMemo, useState } from 'react';
import type { NewsArticle } from '@/types/news';
import NewsCard from '@/components/base/NewsCard';

interface LatestNewsProps {
  articles: NewsArticle[];
  pageSize?: number;
}

export default function LatestNews({ articles, pageSize = 5 }: LatestNewsProps) {
  const [visible, setVisible] = useState(pageSize);

  const sorted = useMemo(
    () => [...articles].sort((a, b) => new Date(b.publishTime).getTime() - new Date(a.publishTime).getTime()),
    [articles],
  );

  const shown = sorted.slice(0, visible);
  const hasMore = visible < sorted.length;

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-6">
      <div className="mb-4 flex items-center justify-between border-b border-background-200 pb-3">
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
          <span className="flex h-6 w-1.5 rounded-full bg-primary-500" />
          最新动态
        </h2>
        <span className="text-xs text-foreground-500">按发布时间倒序</span>
      </div>

      <div className="flex flex-col gap-4">
        {shown.map((article) => (
          <NewsCard key={article.id} article={article} variant="horizontal" />
        ))}
      </div>

      <div className="mt-6 flex justify-center">
        {hasMore ? (
          <button
            type="button"
            onClick={() => setVisible((prev) => prev + pageSize)}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-arrow-down-line" />
            加载更多新闻
          </button>
        ) : (
          <span className="text-xs text-foreground-400">已加载全部 {sorted.length} 条新闻</span>
        )}
      </div>
    </section>
  );
}